export enum VARIANTS {
  FILLED = "filled",
  OUTLINED = "outlined",
  DEFAULT = "default"
}
